import { WifiOffTwoTone } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

const secondaryTextColor = 'text.secondary'

export const OfflineBanner = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      height: '100dvh',
      justifyContent: 'center',
      left: 0,
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: 9999,
    }}
  >
    <WifiOffTwoTone sx={{ color: secondaryTextColor, fontSize: 64 }} />

    <Typography color={secondaryTextColor} variant={'h5'}>
      Sie sind im Offline-Modus.
    </Typography>

    <Typography color={secondaryTextColor} variant={'body1'}>
      Das KARMA Dashboard erfordert eine Online-Verbindung.
    </Typography>
  </Box>
)
